import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Link extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-link": true
    }, className);

    return (
      <a className={ cls } { ...others }>{ children }</a>
    );
  }
}
